import { render, staticRenderFns } from "./ruleAdmin.vue?vue&type=template&id=2e5bfb3c&scoped=true"
import script from "./ruleAdmin.vue?vue&type=script&lang=js"
export * from "./ruleAdmin.vue?vue&type=script&lang=js"
import style0 from "./ruleAdmin.vue?vue&type=style&index=0&id=2e5bfb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bfb3c",
  null
  
)

export default component.exports